import { useRef, useState } from 'react';
import * as S from '~/components/Chat/Chat01/TextBox/TextBox.styled';
import { Member } from '~/types';
import { validateEmail } from '~/utils';
import AIMark from '~/assets/img/icons/chat_ai_mark.svg';

interface MentionListProps {
  members: Member[];
  isOpen: boolean;
  onSelect: (e: any, member: Member) => void;
  mentionListRef: React.RefObject<HTMLUListElement>;
  selectedIndex: number;
  bottomOffset: number;
}

export default function MentionList({
  members,
  isOpen,
  onSelect,
  mentionListRef,
  selectedIndex,
  bottomOffset,
}: MentionListProps) {
  const [isScrolling, setIsScrolling] = useState(false);
  const touchStartY = useRef(0);
  const touchStartX = useRef(0);
  const threshold = 10; // 스크롤과 터치 구분을 위한 임계값

  const handleTouchStart = (e: React.TouchEvent<HTMLLIElement>) => {
    touchStartY.current = e.touches[0].clientY;
    touchStartX.current = e.touches[0].clientX;
    setIsScrolling(false);
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLLIElement>) => {
    const touchMoveY = e.touches[0].clientY;
    const touchMoveX = e.touches[0].clientX;

    if (
      Math.abs(touchMoveY - touchStartY.current) > threshold ||
      Math.abs(touchMoveX - touchStartX.current) > threshold
    ) {
      setIsScrolling(true);
    }
  };

  const handleTouchEnd = (
    e: React.TouchEvent<HTMLLIElement>,
    member: Member,
  ) => {
    if (!isScrolling) {
      onSelect(e, member);
    }
  };

  return (
    <>
      {isOpen && (
        <S.MemberList ref={mentionListRef} bottom={bottomOffset}>
          {members.map((member, idx) => (
            <S.MemberBox
              key={`${member.id}_${idx}`}
              selected={idx === selectedIndex}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={(e) => {
                handleTouchEnd(e, member);
              }}
              onClick={(e) => {
                onSelect(e, member);
              }}
            >
              {!validateEmail(member.id) && (
                <S.MemberIcon>
                  <img src={AIMark} alt='ai_icon' />
                </S.MemberIcon>
              )}

              <S.MemberName>{member.name}</S.MemberName>
            </S.MemberBox>
          ))}
        </S.MemberList>
      )}
    </>
  );
}
